import Vue from 'vue';
import { InputCheckbox } from './InputCheckbox';
import { InputDate } from './InputDate';
import { InputSelect } from './InputSelect';
import { InputText } from './InputText';
var InputMaskPatterns = {
    cnpj: '##.###.###/####-##',
    cpf: '###.###.###-##',
    date: '##/##/####',
    dateFormat: 'DD/MM/YYYY',
    datetime: '##/##/#### ##:##',
    datetimeFormat: 'DD/MM/YYYY HH:mm',
    phone: '(##) ####-####',
    phoneAlt: '(##) #####-####',
    rg: '##.###.###-#',
    zipcode: '#####-###',
    zipcodeAlt: '#####-###',
};
var ModalWrapper = /** @class */ (function () {
    function ModalWrapper() {
    }
    ModalWrapper.install = function (maskPatterns) {
        if (maskPatterns) {
            InputMaskPatterns = maskPatterns;
        }
        Vue.component('InputCheckbox', InputCheckbox);
        Vue.component('InputDate', InputDate);
        Vue.component('InputSelect', InputSelect);
        Vue.component('InputText', InputText);
    };
    return ModalWrapper;
}());
export default ModalWrapper;
export { InputCheckbox, InputDate, InputSelect, InputText, InputMaskPatterns };
//# sourceMappingURL=index.js.map